export default __webpack_public_path__ + "static/media/other-country.e9f98ed9.png";